'use client';
import MinimalNav from '@c/MinimalNav';
import SafeImage from '@ui/SafeImage';
import Link from 'next/link';
import { Suspense } from 'react';

type Props = {
  children: React.ReactNode;
  /** Artwork for the left panel. Defaults to the login collage. */
  image?: { src: string; alt: string };
};

export default function OnboardingLayout({ children, image }: Props) {
  return (
    <div className="h-screen w-full overflow-hidden">
      <div className="flex h-full">
        <div className="relative right-0 top-0 hidden h-full w-full max-w-[90rem] select-none overflow-clip bg-gradient-login lg:inline-block">
          <SafeImage
            alt={image?.alt ?? 'Login Image'}
            src={image?.src ?? '/login.webp'}
            priority
            fill
            classes="shadow-2xl"
            className="object-cover"
          />

          <div className="absolute flex h-full flex-col justify-between px-16 py-24">
            <Link href={'/'}>
              <SafeImage
                src={'/mx-login-logo.png'}
                alt="MX Locker Logo"
                width={1080}
                height={1080}
                className="aspect-auto h-[7rem] w-[11rem]"
              />
            </Link>
            <SafeImage
              src={'/the-powersports-marketplace.png'}
              alt="The Powersports Marketplace"
              width={1080}
              height={1080}
              className="h-[15rem] w-auto"
            />
          </div>
        </div>
        <div className="flex h-full w-full flex-col">
          <Suspense>
            <MinimalNav />
          </Suspense>
          <div className="flex-1 overflow-y-auto">{children}</div>
        </div>
      </div>
    </div>
  );
}
